import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import { Box } from '@mui/material';
import AppHeader from './components/AppHeader';
import Login from './pages/Login';
import Inventory from './pages/Inventory';
import MaterialManagement from './pages/MaterialManagement';
import DocumentManagement from './pages/DocumentManagement';
import SalesRegister from './pages/SalesRegister';
import SalesList from './pages/SalesList';
import CompanyRegister from './pages/CompanyRegister';
import ProductionManagement from './pages/ProductionManagement';
import SalesDocuments from './pages/SalesDocuments';
import SalesPlanning from './pages/SalesPlanning';
import ProductionDocument from './pages/ProductionDocument';
import Designs from './pages/Designs';
import UserRegister from './pages/UserRegister';
import MyPage from './pages/MyPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import DocumentSchedule from './pages/DocumentSchedule';
import DocumentBilling from './pages/DocumentBilling';

const drawerWidth = 240;

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token') !== null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <Router>
          <AppHeader />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              mt: 8,
              ml: { sm: 35 },
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute><Inventory /></PrivateRoute>} />
              <Route path="/inventory" element={<PrivateRoute><Inventory /></PrivateRoute>} />
              <Route path="/materials" element={<PrivateRoute><MaterialManagement /></PrivateRoute>} />
              <Route path="/documents" element={<PrivateRoute><DocumentManagement /></PrivateRoute>} />
              <Route path="/document-schedule" element={<PrivateRoute><DocumentSchedule /></PrivateRoute>} />
              <Route path="/documents/sales" element={<PrivateRoute><SalesDocuments /></PrivateRoute>} />
              <Route path="/documents/planning" element={<PrivateRoute><SalesPlanning /></PrivateRoute>} />
              <Route path="/documents/production" element={<PrivateRoute><ProductionDocument /></PrivateRoute>} />
              <Route path="/documents/schedule" element={<PrivateRoute><DocumentSchedule /></PrivateRoute>} />
              <Route path="/documents/billing" element={<PrivateRoute><DocumentBilling /></PrivateRoute>} />
              <Route path="/sales/register" element={<PrivateRoute><SalesRegister /></PrivateRoute>} />
              <Route path="/sales/list" element={<PrivateRoute><SalesList /></PrivateRoute>} />
              <Route path="/company/register" element={<PrivateRoute><CompanyRegister /></PrivateRoute>} />
              <Route path="/production" element={<PrivateRoute><ProductionManagement /></PrivateRoute>} />
              <Route path="/designs" element={<PrivateRoute><Designs /></PrivateRoute>} />
              <Route path="/users/register" element={<PrivateRoute><UserRegister /></PrivateRoute>} />
              <Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />
            </Routes>
          </Box>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
